import React from "react";
import { Box, Typography } from "@mui/material";
import CreatableSelect from "react-select/creatable";
import HistoricMenuList from "./HistoricMenuList";
import { HISTORIC_LABELED_CREATABLE } from "../../../../pages/SHARED/Bond Creation Historic/components/historicCreationSharedPropTypes";
import { historicCreatableSelectStyles } from "../creatableSelectStyles";

const HistoricLabeledCreatableSelect = ({
  label,
  options,
  value,
  onChange,
  placeholder,
}) => (
  <Box sx={{ marginBottom: "2px" }}>
    <Typography
      sx={{
        fontSize: "12px",
        color: "rgba(0, 0, 0, 0.6)",
        marginBottom: "4px",
        fontWeight: 500,
      }}
    >
      {label}
    </Typography>
    <CreatableSelect
      isClearable
      options={options}
      components={{ MenuList: HistoricMenuList }}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      styles={historicCreatableSelectStyles}
    />
  </Box>
);

HistoricLabeledCreatableSelect.propTypes = HISTORIC_LABELED_CREATABLE;

export default HistoricLabeledCreatableSelect;
